export interface ArticleMeta {
  slug: string;
  keyPrefix: string;
}

/**
 * Central registry of all SEO articles. Each article has a slug (used in the
 * URL) and a keyPrefix (used to look up its i18n translation keys).
 */
export const articles: ArticleMeta[] = [
  { slug: 'usfans-spreadsheet-guide', keyPrefix: 'article' },
  { slug: 'usfans-review', keyPrefix: 'review' },
  { slug: 'usfans-shipping-cost', keyPrefix: 'shipping' },
  { slug: 'usfans-coupon', keyPrefix: 'coupon' },
  { slug: 'usfans-warehouse', keyPrefix: 'warehouse' },
  { slug: 'usfans-legit', keyPrefix: 'legit' },
  { slug: 'usfans-creator-directory', keyPrefix: 'creator' },
  { slug: 'usfans-spreadsheet-search', keyPrefix: 'search' },
  { slug: 'usfans-safety', keyPrefix: 'safety' },
  { slug: 'usfans-faq', keyPrefix: 'faq' },
  { slug: 'usfans-alternatives', keyPrefix: 'alternatives' },
  { slug: 'usfans-shipping-options', keyPrefix: 'shippingopts' },
  { slug: 'usfans-discount-code', keyPrefix: 'discount' },
  { slug: 'usfans-beginner-guide', keyPrefix: 'beginner' },
];

/**
 * Related-article recommendations for each article. Every article links to
 * 3 other articles to build hub-and-spoke internal linking.
 */
export const relatedArticles: Record<string, string[]> = {
  'usfans-spreadsheet-guide': ['usfans-review', 'usfans-shipping-cost', 'usfans-coupon'],
  'usfans-review': ['usfans-shipping-cost', 'usfans-coupon', 'usfans-spreadsheet-guide'],
  'usfans-shipping-cost': ['usfans-coupon', 'usfans-review', 'usfans-spreadsheet-guide'],
  'usfans-coupon': ['usfans-review', 'usfans-shipping-cost', 'usfans-spreadsheet-guide'],
  'usfans-warehouse': ['usfans-shipping-cost', 'usfans-shipping-options', 'usfans-spreadsheet-guide'],
  'usfans-legit': ['usfans-safety', 'usfans-review', 'usfans-spreadsheet-guide'],
  'usfans-creator-directory': ['usfans-spreadsheet-search', 'usfans-spreadsheet-guide', 'usfans-beginner-guide'],
  'usfans-spreadsheet-search': ['usfans-spreadsheet-guide', 'usfans-creator-directory', 'usfans-beginner-guide'],
  'usfans-safety': ['usfans-legit', 'usfans-spreadsheet-guide', 'usfans-faq'],
  'usfans-faq': ['usfans-spreadsheet-guide', 'usfans-safety', 'usfans-beginner-guide'],
  'usfans-alternatives': ['usfans-review', 'usfans-shipping-cost', 'usfans-spreadsheet-guide'],
  'usfans-shipping-options': ['usfans-shipping-cost', 'usfans-warehouse', 'usfans-spreadsheet-guide'],
  'usfans-discount-code': ['usfans-coupon', 'usfans-review', 'usfans-spreadsheet-guide'],
  'usfans-beginner-guide': ['usfans-spreadsheet-guide', 'usfans-creator-directory', 'usfans-faq'],
};

export function getKeyPrefix(slug: string): string {
  const found = articles.find((a) => a.slug === slug);
  return found ? found.keyPrefix : 'article';
}